import type {FilterObject} from 'nutshell-core/types';

/*
 * Transform createdTime to closedTime
 */
export function getTransformedFilters(filters: Array<FilterObject>): Array<FilterObject> {
    return filters.map((item) => {
        if ('createdTime' in item) {
            const {createdTime, ...rest} = item;

            return {closedTime: createdTime, ...rest};
        }

        return item;
    });
}

/*
 * For the sales report, we need to add the origin and status filters,
 * and switch the created time to closed time.
 */
export function addReportSpecificFilters(filters: Array<FilterObject>): Array<FilterObject> {
    const transformedFilters = getTransformedFilters(filters);

    // Use engagement filter for V2, fallback to origin filter for V1
    const originData = NutClientConfig.hasEngagementBarV2FF
        ? NutshellFrontendSettings.engagementOriginApiIds.map((data: string) => ({data}))
        : getV1OriginData();

    return [...transformedFilters, {origin: originData}, {status: 'won'}];
}

export function getV1OriginData() {
    const {originApiIdChat, originApiIdChatbot, originApiIdOfflineForm} = NutshellFrontendSettings;

    return [originApiIdChat, originApiIdChatbot, originApiIdOfflineForm]
        .filter(Boolean)
        .map((origin) => ({data: origin}));
}
